import { Component, Optional, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { BusinessTransactionService } from '../../../shared/services/business-transaction/business-transaction.service';

export class TransactionDeleteWindowContext {
    constructor(
        public businessTransactionNumberId: string) {}
}

@Component({
    selector: 'transaction-delete-modal',
    templateUrl: './transaction-delete-modal.html'
})

export class TransactionDeleteWindow extends BaseComponent {
    public hasReceipts = false;
    public callCompleted = false;

    constructor(public dialogRef: MatDialogRef<TransactionDeleteWindow>,
        public businessTransactionService: BusinessTransactionService,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: TransactionDeleteWindowContext) {
        super();
    }

    ngOnInit() {
        this.businessTransactionService.expireBusinessTransactionHasReceipts(this.data.businessTransactionNumberId)
            .subscribe(
                r => {
                    this.hasReceipts = r.result;
                    this.callCompleted = true;
                },
                error => this.handleValidationResult(error));
    }

    public accept() {
        this.dialogRef.close(true);
    }

    public cancel() {
        this.dialogRef.close();
    }
}
